import Qwery from 'qwery'
import Cookies from 'js-cookie'

import { debug, subscribe, removeElementsByClassName } from './utilities'
import { predictPlaceholders, elementVisible } from './features'

const languages = {
  'abkhaz': 'ab',
  'afar': 'aa',
  'afrikaans': 'af',
  'akan': 'ak',
  'albanian': 'sq',
  'amharic': 'am',
  'arabic': 'ar',
  'aragonese': 'an',
  'armenian': 'hy',
  'assamese': 'as',
  'avaric': 'av',
  'avestan': 'ae',
  'aymara': 'ay',
  'azerbaijani': 'az',
  'bambara': 'bm',
  'bashkir': 'ba',
  'basque': 'eu',
  'belarusian': 'be',
  'bengali': 'bn',
  'bihari': 'bh',
  'bislama': 'bi',
  'bosnian': 'bs',
  'breton': 'br',
  'bulgarian': 'bg',
  'burmese': 'my',
  'catalan; valencian': 'ca',
  'chamorro': 'ch',
  'chechen': 'ce',
  'chichewa; chewa; nyanja': 'ny',
  'chinese': 'zh',
  'chuvash': 'cv',
  'cornish': 'kw',
  'corsican': 'co',
  'cree': 'cr',
  'croatian': 'hr',
  'czech': 'cs',
  'danish': 'da',
  'divehi; dhivehi; maldivian;': 'dv',
  'dutch': 'nl',
  'english': 'en',
  'esperanto': 'eo',
  'estonian': 'et',
  'ewe': 'ee',
  'faroese': 'fo',
  'fijian': 'fj',
  'finnish': 'fi',
  'french': 'fr',
  'fula; fulah; pulaar; pular': 'ff',
  'galician': 'gl',
  'georgian': 'ka',
  'german': 'de',
  'greek, modern': 'el',
  'guaraní': 'gn',
  'gujarati': 'gu',
  'haitian; haitian creole': 'ht',
  'hausa': 'ha',
  'hebrew (modern)': 'he',
  'hebrew': 'he',
  'herero': 'hz',
  'hindi': 'hi',
  'hiri motu': 'ho',
  'hungarian': 'hu',
  'interlingua': 'ia',
  'indonesian': 'id',
  'interlingue': 'ie',
  'irish': 'ga',
  'igbo': 'ig',
  'inupiaq': 'ik',
  'ido': 'io',
  'icelandic': 'is',
  'italian': 'it',
  'inuktitut': 'iu',
  'japanese': 'ja',
  'javanese': 'jv',
  'kalaallisut, greenlandic': 'kl',
  'kannada': 'kn',
  'kanuri': 'kr',
  'kashmiri': 'ks',
  'kazakh': 'kk',
  'khmer': 'km',
  'kikuyu, gikuyu': 'ki',
  'kinyarwanda': 'rw',
  'kirghiz, kyrgyz': 'ky',
  'komi': 'kv',
  'kongo': 'kg',
  'korean': 'ko',
  'kurdish': 'ku',
  'kwanyama, kuanyama': 'kj',
  'latin': 'la',
  'luxembourgish, letzeburgesch': 'lb',
  'luganda': 'lg',
  'limburgish, limburgan, limburger': 'li',
  'lingala': 'ln',
  'lao': 'lo',
  'lithuanian': 'lt',
  'luba-katanga': 'lu',
  'latvian': 'lv',
  'manx': 'gv',
  'macedonian': 'mk',
  'malagasy': 'mg',
  'malay': 'ms',
  'malayalam': 'ml',
  'maltese': 'mt',
  'māori': 'mi',
  'marathi (marāṭhī)': 'mr',
  'marshallese': 'mh',
  'mongolian': 'mn',
  'nauru': 'na',
  'navajo, navaho': 'nv',
  'norwegian bokmål': 'nb',
  'north ndebele': 'nd',
  'nepali': 'ne',
  'ndonga': 'ng',
  'norwegian nynorsk': 'nn',
  'norwegian': 'no',
  'nuosu': 'ii',
  'south ndebele': 'nr',
  'occitan': 'oc',
  'ojibwe, ojibwa': 'oj',
  'old church slavonic, church slavic, church slavonic, old bulgarian, old slavonic': 'cu',
  'oromo': 'om',
  'oriya': 'or',
  'ossetian, ossetic': 'os',
  'panjabi, punjabi': 'pa',
  'pāli': 'pi',
  'persian': 'fa',
  'polish': 'pl',
  'pashto, pushto': 'ps',
  'portuguese': 'pt',
  'quechua': 'qu',
  'romansh': 'rm',
  'kirundi': 'rn',
  'romanian': 'ro',
  'russian': 'ru',
  'sanskrit (saṁskṛta)': 'sa',
  'sardinian': 'sc',
  'sindhi': 'sd',
  // 'northern sami': 'se',
  'samoan': 'sm',
  'sango': 'sg',
  'serbian': 'sr',
  'scottish gaelic; gaelic': 'gd',
  'shona': 'sn',
  'sinhala, sinhalese': 'si',
  'slovak': 'sk',
  'slovene': 'sl',
  'somali': 'so',
  'southern sotho': 'st',
  'spanish; castilian': 'es',
  'sundanese': 'su',
  'swahili': 'sw',
  'swati': 'ss',
  'swedish': 'sv',
  'tamil': 'ta',
  'telugu': 'te',
  'tajik': 'tg',
  'thai': 'th',
  'tigrinya': 'ti',
  'tibetan standard, tibetan, central': 'bo',
  'turkmen': 'tk',
  'tagalog': 'tl',
  'tswana': 'tn',
  'tonga (tonga islands)': 'to',
  'turkish': 'tr',
  'tsonga': 'ts',
  'tatar': 'tt',
  'twi': 'tw',
  'tahitian': 'ty',
  'uighur, uyghur': 'ug',
  'ukrainian': 'uk',
  'urdu': 'ur',
  'uzbek': 'uz',
  'venda': 've',
  'vietnamese': 'vi',
  'volapük': 'vo',
  'walloon': 'wa',
  'welsh': 'cy',
  'wolof': 'wo',
  'western frisian': 'fy',
  'xhosa': 'xh',
  'yiddish': 'yi',
  'yoruba': 'yo',
  'zhuang, chuang': 'za'
}

export function getQaAdvisorLink (params) {
  let url = params.easysize.qa_widget_url
  let language = 'en'

  if (languages.hasOwnProperty(params.shop.language)) {
    language = languages[params.shop.language]
  }

  let widget_url = `${url}${language}/${params.shop.generated_shop_id}?` +
    // 'css='+cps+
    'product_brand_id=' + params.product.brand_id +
    '&product_fit_id=' + encodeURIComponent(params.product.fit_id) +
    '&product_type_id=' + params.product.category_id +
    '&product_id=' + params.product.id +
    '&product_brand=' + encodeURIComponent(params.product.brand) +
    '&product_type=' + encodeURIComponent(params.product.category) +
    '&product_gender=' + params.product.gender +
    '&product_model=' + encodeURIComponent(params.product.model) +
    '&product_fit=' + encodeURIComponent(params.product.fit) +
    '&available_fits=' + encodeURIComponent(params.product.available_fits) +
    '&available_lengths=' + encodeURIComponent(params.product.available_lengths) +
    '&selected_options=' + encodeURIComponent(params.product.selected_options) +
    '&product_sku=' + encodeURIComponent(params.product.sku) +
    '&product_url=' + encodeURIComponent(window.location.href) +
    '&sizes_in_stock=' + encodeURIComponent(JSON.stringify(params.product.stock)) +
    '&product_tags=' + encodeURIComponent(JSON.stringify(params.product.tags)) +
    '&fits_in_stock=' + encodeURIComponent(JSON.stringify(params.product.fits_in_stock)) +
    '&product_title=' + encodeURIComponent(params.product.title) +
    '&language=' + params.shop.language +
    '&session_id=' + params.easysize.pageview_id +
    '&origin_url=' + encodeURIComponent(document.URL) +
    '&easysize_user_id=' + params.easysize.user_id +
    '&api_url=' + encodeURIComponent(params.easysize.api_url) +
    '&product_type_english=' + encodeURIComponent(params.product.category_title) +
    '&product_type_article=' + encodeURIComponent(params.product.category_article) +
    '&product_type_gender=' + encodeURIComponent(params.product.category_gender) +
    '&product_type_collective_noun=' + encodeURIComponent(params.product.category_collective_noun) +
    '&product_image=' + encodeURIComponent(params.product.image_url) +
    '&custom_css=' + encodeURIComponent(params.shop.custom_css) +
    '&esnt=' + Cookies.get('esnt');

  if (params.shop.size_guide_url) {
    widget_url += `&size_guide_url=${params.shop.size_guide_url}`
  }

  if (params.product.subcategory) {
    widget_url += `&p_subcategory=${params.product.subcategory}`
  }
  return widget_url
}

export function startQaAdvisor (params, page) {
  if (params.easysize.opened) return

  params.easysize.opened = true // mark easysize as opened
  document.body.classList.add('es-qa-advisor-open')
  

  if (document.getElementById('es-mobile-no-zoom')) {
    document.getElementById('es-mobile-no-zoom').setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no')
  } else {
    var meta = document.createElement('meta')
    meta.id = 'es-mobile-no-zoom'
    meta.setAttribute('name', 'viewport')
    meta.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no')
    document.head.appendChild(meta)
  }

  let popup, iframe, img

  popup = document.createElement('div')
  popup.id = 'es-background'
  popup.style.background = 'rgba(0, 0, 0, 0.6)'
  popup.style.position = 'fixed'
  popup.style.top = '0'
  popup.style.left = '0'
  popup.style.width = '100%'
  popup.style.height = '100%'
  popup.style.zIndex = '2147483646'

  // Create iframe
  iframe = document.createElement('iframe')
  Object.keys(params.easysize.widget_iframe_attributes).forEach((attr) => {
    iframe.setAttribute(attr, params.easysize.widget_iframe_attributes[attr])
  })

  iframe.id = 'easysize_popup'
  iframe.src = getQaAdvisorLink(params)

  if (page) {
    delete params.easysize.original_calculated_size.better_matches
    iframe.src = `${iframe.src}&page=${page}&calculated_size=${JSON.stringify(params.easysize.original_calculated_size)}`
  }

  iframe.style.border = 0
  iframe.style.width = '100%'
  iframe.style.height = '100%'
  iframe.className = 'hidden'

  // Create img for nice UX
  img = document.createElement('img')
  img.src = 'https://webapp.easysize.me/web_app_v1.0/icons/ajax-loader.svg'
  img.style.position = 'fixed'
  img.style.width = '40px'
  img.style.height = 'auto'
  img.style.top = '40%'
  img.style.right = '0'
  img.style.left = '0'
  img.style.margin = '0 auto'

  popup.appendChild(img)

  iframe.onload = function () {
    popup.removeChild(img)
    iframe.className = ''
    iframe.focus()
  }

  popup.appendChild(iframe) // append iframe to popup
  document.body.appendChild(popup) // append popup to DOM

  window.postMessage(JSON.stringify({
    'easysize_tracking': true,
    'action': 2
  }), '*')
}

export function embed (params, page) {
  let iframe = document.createElement('iframe')
  Object.keys(params.easysize.widget_iframe_attributes).forEach((attr) => {
    iframe.setAttribute(attr, params.easysize.widget_iframe_attributes[attr])
  })

  iframe.id = 'easysize_popup'
  iframe.src = `${getQaAdvisorLink(params)}&embedded=1`

  iframe.style.border = 0
  iframe.style.width = '100%'
  iframe.style.height = '100%'
  iframe.className = 'easysize-embed-iframe'

  Array.from(document.querySelectorAll('.easysize-embed')).forEach((i) => {
    i.innerHTML = ''
    i.appendChild(iframe)
  })
}

export function closeQaAdvisor (params) {
  debug('[EasySize] Closing qa advisor')

  window.postMessage(JSON.stringify({
    'easysize_tracking': true,
    'action': 9
  }), '*')

  params.easysize.opened = false
  document.body.classList.remove('es-qa-advisor-open')

  if (document.getElementById('es-mobile-no-zoom') && params.shop.current_meta_viewport) {
    document.getElementById('es-mobile-no-zoom').setAttribute('content', params.shop.current_meta_viewport)
  }

  if (!document.getElementById('es-background')) { return }
  // Fade out the popup
  var fadeTarget = document.getElementById('es-background')

  if (!fadeTarget.style.opacity) { fadeTarget.style.opacity = 1 }

  for (var i = 1; i < 11; i++) {
    (function (i) {
      setTimeout(function () {
        fadeTarget.style.opacity -= 0.1
        if (i === 10) {
          fadeTarget.style.display = 'none'
        }
      }, i * 20)
    })(i)
  }

  setTimeout(function () {
    try {
      document.body.removeChild(document.getElementById('es-background'))
    } catch (e) {}
  }, 2000)
}

export function addSizeRecommendedText (className, text, appendBody, params) {
  if (!params.easysize.dom_updates) {
    debug('Easysize turned off addSizeRecommendedText')
    return
  }

  debug('sa-qa addSizeRecommendedText')
  // easysize_tracking_initiated
  if (params.easysize.pageview_id === -1) {
    subscribe('easysize_tracking_initiated', () => {
      addSizeRecommendedText(className, text, appendBody, params)
    })
  } else if (!params.button.loaded_from_server) {
    setTimeout(() => {
      addSizeRecommendedText(className, text, appendBody, params)
    }, 100)
  } else {
    removeElementsByClassName('es-selected')
    removeElementsByClassName('es-recommended')

    let rtext = document.createElement('p')
    rtext.className = className
    rtext.innerHTML = params.button[text].replace('{n}', params.easysize.calculated_size_proven_by)
    rtext.tabIndex = 0
    rtext.role = 'button'
    rtext.onclick = function() {
      startQaAdvisor(params)
    }

    var recommended_size = params.easysize.calculated_size

    // Append recommended length to size prediction if available
    try {
      if (params.easysize.original_calculated_size.recommended_length && params.product.available_lengths.indexOf(params.easysize.original_calculated_size.recommended_length) !== -1) {
        recommended_size = `${params.easysize.calculated_size} / ${params.easysize.original_calculated_size.recommended_length}`
      }
    } catch (e) { debug(e) }

    if (params.easysize.hasOwnProperty('recommended_fit')) {
      if (params.easysize.recommended_fit && params.easysize.recommended_fit !== '*' && params.product.available_fits.indexOf(params.easysize.recommended_fit) !== -1) {
        if (rtext.innerHTML.indexOf('{recommended_fit}') !== -1) {
          rtext.innerHTML = rtext.innerHTML.replace('{recommended_fit}', params.easysize.recommended_fit)
        } else if (params.features.hasOwnProperty('append_size_with_recommended_fit')) {
          // If recommended_fit exists but it's not part of the text, append it at the end
          rtext.innerHTML = rtext.innerHTML.replace('{s}', `{s} / ${params.easysize.recommended_fit}`)
        }
      } else {
        if (params.features.hasOwnProperty('append_size_with_recommended_fit_fallback')) {
          // fallback to provided text if fit does not exist
          rtext.innerHTML = params.features.append_size_with_recommended_fit_fallback
        }
      }
      rtext.innerHTML = rtext.innerHTML.replace('{s}', recommended_size)
    } else if (params.features.hasOwnProperty('append_size_with_recommended_fit_fallback')) {
      // fallback to provided text if fit does not exist
      rtext.innerHTML = params.features.append_size_with_recommended_fit_fallback
    }

    let recommended_fit = params.easysize.original_calculated_size.recommended_fit
    let fit_tags = ['f', 'fit', 'recommended_fit']
    if (recommended_fit && params.product.available_fits.indexOf(recommended_fit) !== -1) {
      fit_tags.forEach(function(tag) {
        rtext.innerHTML = rtext.innerHTML.replace('{'+ tag +'}', recommended_fit)
      })
    }


    // hardcoded fallback of recommended fit
    let hardcoded_fit_fallbacks = [
      'in {tag}',
      'in {tag} fit',
      ' / <i>{tag}</i>',
      '{tag}'
    ]
    fit_tags.forEach(function(tag) {
      hardcoded_fit_fallbacks.forEach(function(hardcoded_fallback) {
        let fallback = hardcoded_fallback.replace('{tag}', '{'+ tag +'}')
        rtext.innerHTML = rtext.innerHTML.replace(fallback, '')
      })
    })

    rtext.innerHTML = rtext.innerHTML.replace('{s}', recommended_size)

    // Add extra elements if any added
    if (params.elements.extra && params.elements.extra.size_selector) {
      for (var i = 0; i < params.elements.extra.size_selector.length; i++) {
        let el = Qwery(params.elements.extra.size_selector[i])[0]

        if (el) {
          el.parentNode.insertBefore(rtext.cloneNode(true), el.nextSibling)
        }
      }
    }

    // Append after size selector
    try {
      if (params.shop.recommendation_placeholder) {
        Qwery(params.shop.recommendation_placeholder)[0].appendChild(rtext)
      } else if (params.elements.size_dropdown) {
        let placeholder = params.elements.size_dropdown
        if (params.elements.extra.hasOwnProperty('returning_user_text_placeholder')) {
          placeholder = Qwery(params.elements.extra.returning_user_text_placeholder[0])[0]

          if (!placeholder) {
            placeholder = params.elements.size_dropdown
          }
        }

        try {
          placeholder[params.elements.button_r_position](rtext)
        } catch(e) {
          debug('[EasySize] Issue adding returning user message', e)
          placeholder.parentNode.insertBefore(rtext, placeholder.nextSibling)
        }
      } else {
        params.elements.button_placeholder.appendChild(rtext)
      }
    } catch(e) {
      debug('[EasySize] Issue appending returning user message')
    }

    let es_placeholder = Qwery(params.shop.recommendation_placeholder)[0] || params.elements.size_dropdown || Qwery(params.shop.size_dropdown_selector)[0]
    if (!es_placeholder || !elementVisible(es_placeholder)) {
      es_placeholder = predictPlaceholders(params) || es_placeholder
    }

    try {
      if (es_placeholder) {
        es_placeholder[params.elements.button_r_position](rtext)
      } else {
        setTimeout(function() {
          debug('[EasySize] Returning user placeholder doesnt exist, trying again')
          addSizeRecommendedText(className, text, appendBody, params)
        }, 50)
      }
    } catch(e) {
      debug('[EasySize] Issue adding returning user message', e)
      es_placeholder.parentNode.insertBefore(rtext, es_placeholder.nextSibling)
    }

    document.body.classList.add(appendBody)
    window.dispatchEvent(new CustomEvent('easysize_loaded__returning', { 
      detail: {
        recommended_size: params.easysize.original_calculated_size.size
      }
    }))
  }
}



// WEBPACK FOOTER //
// ./src/js/components/size-advisor-qa.js